import { createGlobalStyle } from 'styled-components';
import { DatePickerStylesCustomization } from './lib-style-overwrite';
import { NATIVE_TABBAR_SPACE } from './native-tabbar-space';
import { mediaQuery } from './variables';

const toastBottomContainers = `
  .Toastify__toast-container.Toastify__toast-container--bottom-left,
  .Toastify__toast-container.Toastify__toast-container--bottom-center,
  .Toastify__toast-container.Toastify__toast-container--bottom-right
`;

export const FleetServicesGlobalStyle = createGlobalStyle`
  :root {
    --ui-white: ${({ theme }) => theme.colors.white};
    --ui-black: ${({ theme }) => theme.colors.black};
    --ui-gray100: ${({ theme }) => theme.colors.grey100};
    --ui-gray200: ${({ theme }) => theme.colors.grey200};
    --ui-gray300: ${({ theme }) => theme.colors.grey300};
    --ui-gray400: ${({ theme }) => theme.colors.grey400};
    --ui-gray500: ${({ theme }) => theme.colors.grey500};
    --ui-gray600: ${({ theme }) => theme.colors.grey600};
    --ui-gray700: ${({ theme }) => theme.colors.grey700};
    --ui-gray800: ${({ theme }) => theme.colors.grey800};
    --functional-error: ${({ theme }) => theme.colors.red500};
    --functional-success: ${({ theme }) => theme.colors.green500};
    --functional-caution: ${({ theme }) => theme.colors.yellow500};
    --functional-progress: ${({ theme }) => theme.colors.blue500};
    --brand-100: ${({ theme }) => theme.colors.orange500};
    --brand-110: ${({ theme }) => theme.colors.orange500};
    --orange-600: ${({ theme }) => theme.colors.orange600};
    --primary: ${({ theme }) => theme.colors.primary};
    --on-primary: ${({ theme }) => theme.colors.onPrimary};
    --on-surface: ${({ theme }) => theme.colors.onSurface};
    --on-background: ${({ theme }) => theme.colors.onBackground};
    --background: ${({ theme }) => theme.colors.background};
    --surface: ${({ theme }) => theme.colors.surface};
    --hqv-blue: #273a60;
    --cvh: 1vh; /* Custom viewport height variable, fallback for useCustomViewportHeight hook */
  }

  html {
    height: 100%;
    font-variant-ligatures: none;

    * {
      font-variant-ligatures: none;
    }
  }
  body{
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: var(--background);
      box-sizing: border-box;
      font-family: ${({ theme }) => theme.fontFamily};
    &.scroll-down {
      ${mediaQuery.down.s`
        #application-header {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.35s ease-out;
        }
      `}
    }
  }
  body>div {/* Needed due to hudskit setting fixed values here */
    width: unset;
    height: unset;
    padding: unset;
    margin: unset;
    box-sizing: unset;
  }
  #app{
    height: 100%;
  }
  h1 {
    font-size: 26px;
  }
  h2 {
    font-size: 22px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 16px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 0px;
  }
   /* TODO: Remove once this is fixed: https://github.com/Hacker0x01/react-datepicker/issues/3672 */
   .react-datepicker__navigation--years::before {
    border-color: #666;
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: '';
    display: block;
    height: 9px;
    left: 11px;
    position: absolute;
    width: 9px;
  }

  .react-datepicker__navigation--years-upcoming::before {
    top: 17px;
    transform: rotate(315deg);
  }

  .react-datepicker__navigation--years-previous::before {
    top: 6px;
    transform: rotate(135deg);
  }

  /** this webkit injection is to prevent default browser behavior in the android and IOS devices (MAUI)  */
  a{
    -webkit-tap-highlight-color: transparent!important;
  }
  ${DatePickerStylesCustomization}

  .rc-slider-disabled{
    background-color:transparent !important;
  }

  ${toastBottomContainers} {
    bottom: max(var(--toastify-toast-bottom), ${NATIVE_TABBAR_SPACE});
  }

  @media only screen and (max-width: 480px) {
    ${toastBottomContainers} {
      bottom: max(env(safe-area-inset-bottom), ${NATIVE_TABBAR_SPACE});
    }
  }
`;

export { borderRadius, headerHeight, paddings, shadows, mediaQuery, colors } from './variables';
